var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "div",
    [
      _vm.loadingApps || _vm.loadingAppsError
        ? _c(
            "v-container",
            {
              attrs: {
                fluid: ""
              }
            },
            [
              _c(
                "gg-card",
                [
                  _c(
                    "gg-card-text",
                    [
                      _vm.loadingApps
                        ? _c(
                            "v-row",
                            [
                              _c(
                                "v-col",
                                {
                                  staticClass: "text-center",
                                  attrs: {
                                    cols: "12"
                                  }
                                },
                                [
                                  _c("v-progress-circular", {
                                    staticClass: "my-4",
                                    attrs: {
                                      indeterminate: "",
                                      width: "2",
                                      size: "64",
                                      color: "primary"
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          )
                        : _vm.loadingAppsError
                        ? _c(
                            "v-row",
                            [
                              _c(
                                "v-col",
                                {
                                  staticClass: "text-center",
                                  attrs: {
                                    cols: "12"
                                  }
                                },
                                [
                                  _c(
                                    "v-icon",
                                    {
                                      attrs: {
                                        size: "180",
                                        color: "red"
                                      }
                                    },
                                    [_vm._v("mdi-close-circle")]
                                  ),
                                  _c("p", [
                                    _vm._v(_vm._s(_vm.loadingAppsError))
                                  ])
                                ],
                                1
                              ),
                              _c(
                                "v-col",
                                {
                                  staticClass: "text-center",
                                  attrs: {
                                    cols: "12"
                                  }
                                },
                                [
                                  _c(
                                    "gg-btn",
                                    {
                                      attrs: {
                                        tile: ""
                                      },
                                      on: {
                                        click: function click($event) {
                                          return _vm.setStep(1)
                                        }
                                      }
                                    },
                                    [_vm._v(" Back ")]
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        : _vm._e()
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        : _c(
            "div",
            {
              staticClass: "pt-6"
            },
            [
              _c(_vm.activeComponent, {
                tag: "component",
                attrs: {
                  "loading-apps": _vm.loadingApps,
                  "apps-error": _vm.loadingAppsError,
                  loading: _vm.loading
                },
                on: {
                  submit: _vm.submit
                }
              })
            ],
            1
          )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }